/* src/app/indirect-rate/indirect-rate-history/indirect-rate-history-presenter/indirect-rate-history-presenter.component.scss */
/*# sourceMappingURL=indirect-rate-history-presenter.component.css.map */
